<template>
  <my-dialog-form
    :form-title="formTitle"
    :dialog-form-visible="dialogFormVisible"
    :width="1235"
    :his-system="hisSystem"
    @confirmOk="dialogFormVisible = false"
  >
    <template #body>
      <el-form :model="ruleForm">
        <el-form-item>
          <el-row>
            <el-col :span="3" :offset="1"><span>姓名：</span></el-col>
            <el-col
              :span="3"
            >
              <el-input v-model="ruleForm.nadiaInput"/>
            </el-col>
            <el-col :span="2" :offset="1"><span>年龄：</span></el-col>
            <el-col :span="2" class="hisAgeInput">
              <el-input v-model="ruleForm.agediaInput"/>
            </el-col>
            <el-col :span="3" :offset="1" class="hisAgeSelect">
              <el-select v-model="ruleForm.birthUnit" placeholder="请选择">
                <el-option/>
              </el-select>
            </el-col>
            <el-col :span="2" :offset="1"><span>性别：</span></el-col>
            <el-col :span="3" :offset="0">
              <el-select v-model="ruleForm.gender" placeholder="请选择">
                <el-option/>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="3" :offset="1"><span>身份证号码：</span></el-col>
            <el-col
              :span="9"
              class="hisIdInput"
            >
              <el-input v-model="ruleForm.iddiaInput"/>
            </el-col>
            <el-col :span="3" :push="1"><span>联系电话：</span></el-col>
            <el-col
              :span="6"
            >
              <el-input v-model="ruleForm.phonediaInput"/>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="3" :offset="1"><span>住址：</span></el-col>
            <el-col
              :span="13"
            >
              <el-input v-model="ruleForm.addressdiaInput"/>
            </el-col>
            <el-col :span="5" class="clickBtn">
              <el-button @click="searchClick">搜索</el-button>
              <el-button @click="reset">重置</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-table :data="tableData" height="250" border>
            <el-table-column type="selection" width="50"/>
            <el-table-column label="序号" width="75"/>
            <el-table-column label="姓名" width="75"/>
            <el-table-column label="年龄" width="75"/>
            <el-table-column label="性别" width="75"/>
            <el-table-column label="身份证" width="180"/>
            <el-table-column label="联系电话" width="105"/>
            <el-table-column label="住址" width="150"/>
            <el-table-column label="就诊卡号" width="180"/>
            <el-table-column label="过敏史" width="115"/>
            <el-table-column label="就诊史" width="115"/>
          </el-table>
        </el-form-item>
        <el-form-item>
          <div class="hisButton">
            <el-button>关联</el-button>
          </div>
        </el-form-item>
      </el-form>
    </template>
  </my-dialog-form>
</template>
<script>
import MyDialogForm from "@components/customDialog/MyDialogForm.vue";

export default {
  name: "ConnectHis",

  components: {
    MyDialogForm
  },
  data() {
    return {
      identify: "", // 身份证
      type: "",
      dialogFormVisible: false,
      formTitle: "HIS系统",
      tableData: [], // HIS搜索结果
      hisSystem: true,
      ruleForm: {
        // HIS系统表单
        nadiaInput: "",
        agediaInput: "",
        birthUnit: "",
        gender: "",
        iddiaInput: "",
        phonediaInput: "",
        addressdiaInput: ""
      }
    };
  },
  created() {
    const all = this.$route.path.split("/");
    this.type = all[1];
  },
  methods: {
    reset() {
    },
    searchClick() {
    },
  }
};
</script>
<style lang="scss" scoped>
//.identify {
//  padding-left: 10px;
//  line-height: 40px;
//}

//.connect-container {
//  width: 1200px;
//  margin: 8px auto auto;
//}

.el-button {
  width: 100px;
  min-height: 30px;
  border: 1px solid #0c618b;
  border-radius: 6px;
  font-size: 18px;
  font-weight: bold;
  color: #0c618b;
  line-height: 0;
  margin-top: 4px;
}

.hisButton {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .el-button {
    width: 80px;
    height: 30px;
    border: 1px solid #0c618b;
    border-radius: 6px;
    font-size: 18px;
    font-weight: bold;
    color: #0c618b;
  }
}

.clickBtn {
  .el-button {
    width: 100px;
    min-height: 30px;
    border: 1px solid #0c618b;
    border-radius: 6px;
    font-size: 18px;
    font-weight: bold;
    color: #0c618b;
    line-height: 0;
    margin-top: 6px;
    margin-left: 24px;
  }
}

.el-divider--horizontal {
  margin: 15px 0;
}
</style>
